import { Button, Form, FormInstance, Popover } from 'antd';
import { t } from 'i18next';
import { FC, useState } from 'react';

import { PopoverWrapper, TitleWrapper } from './InsertMedia.styles';

import { Icon } from '@/components/Icon';
import { InsertFormula } from '@/components/InsertFormula';
import { Upload } from '@/components/Upload';

type Props = {
  answerIndex: number;
  form: FormInstance;
};

export const InsertMedia: FC<Props> = ({ answerIndex, form }) => {
  const [isLoadingImageIndex, setIsLoadingImageIndex] = useState<number>();
  const [isFormulaEditorOpen, setIsFormulaEditorOpen] = useState(false);
  const answers = Form.useWatch('answers', form);

  const handleInsertFormula = (formula?: string) => {
    const updatedAnswers = [...answers];
    updatedAnswers[answerIndex] = { ...updatedAnswers[answerIndex], formula };
    form.setFieldValue('answers', updatedAnswers);
  };

  return (
    <>
      <Popover
        trigger="click"
        content={
          <>
            <TitleWrapper>{t('CommonQuizFormTranslations:INSERT_MEDIA')}</TitleWrapper>
            <PopoverWrapper>
              <Form.Item name={[answerIndex, 'file']}>
                <Upload
                  iconOnly
                  icon="Image"
                  maxCount={1}
                  mode="upload"
                  accept="image/*"
                  multiple={false}
                  showUploadList={false}
                  onChange={() => setIsLoadingImageIndex(undefined)}
                  beforeUpload={() => setIsLoadingImageIndex(answerIndex)}
                />
              </Form.Item>
              <Button onClick={() => setIsFormulaEditorOpen(true)} icon={<Icon i="Function" />} />
            </PopoverWrapper>
          </>
        }>
        <Button
          type="default"
          loading={isLoadingImageIndex === answerIndex}
          icon={<Icon i="OverflowMenuHorizontal" />}
        />
      </Popover>
      <InsertFormula
        isOpen={isFormulaEditorOpen}
        setIsOpen={setIsFormulaEditorOpen}
        onChange={f => handleInsertFormula(f)}
      />
    </>
  );
};
